import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <div className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.22em] ${light ? "text-sky-200" : "text-[var(--blue)]"}`}>
    <span className={`h-px w-8 ${light ? "bg-[var(--lime)]" : "bg-[var(--green)]"}`} />
    {children}
  </div>
);
